var moduleMap = {
	"./useDialogPopup": () => {
		return Promise.all([__webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(2687)]).then(() => (() => ((__webpack_require__(2687)))));
	},
	"./dialogProvider": () => {
		return Promise.all([__webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(190)]).then(() => (() => ((__webpack_require__(190)))));
	},
	"./dialogPopup": () => {
		return Promise.all([__webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(2446)]).then(() => (() => ((__webpack_require__(2446)))));
	},
	"./userProvider": () => {
		return Promise.all([__webpack_require__.e(4967), __webpack_require__.e(3364), __webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(6060), __webpack_require__.e(3266), __webpack_require__.e(5746)]).then(() => (() => ((__webpack_require__(5746)))));
	},
	"./logo": () => {
		return __webpack_require__.e(3887).then(() => (() => ((__webpack_require__(3887)))));
	},
	"./login": () => {
		return Promise.all([__webpack_require__.e(4967), __webpack_require__.e(3364), __webpack_require__.e(3765), __webpack_require__.e(1740), __webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(6060), __webpack_require__.e(3266), __webpack_require__.e(5593), __webpack_require__.e(5499), __webpack_require__.e(6238), __webpack_require__.e(1718)]).then(() => (() => ((__webpack_require__(1670)))));
	},
	"./configurationProvider": () => {
		return Promise.all([__webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(6060), __webpack_require__.e(1223)]).then(() => (() => ((__webpack_require__(1223)))));
	},
	"./languageProvider": () => {
		return Promise.all([__webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(6060), __webpack_require__.e(5499), __webpack_require__.e(4851)]).then(() => (() => ((__webpack_require__(4851)))));
	},
	"./withConfiguration": () => {
		return Promise.all([__webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(6060), __webpack_require__.e(6437)]).then(() => (() => ((__webpack_require__(6437)))));
	},
	"./withUser": () => {
		return Promise.all([__webpack_require__.e(4967), __webpack_require__.e(3364), __webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(6060), __webpack_require__.e(3266), __webpack_require__.e(7863)]).then(() => (() => ((__webpack_require__(7863)))));
	},
	"./withCustomTheme": () => {
		return Promise.all([__webpack_require__.e(7900), __webpack_require__.e(5593), __webpack_require__.e(3275)]).then(() => (() => ((__webpack_require__(3275)))));
	},
	"./userModel": () => {
		return __webpack_require__.e(7698).then(() => (() => ((__webpack_require__(7698)))));
	},
	"./webSocket": () => {
		return Promise.all([__webpack_require__.e(4967), __webpack_require__.e(3364), __webpack_require__.e(7900), __webpack_require__.e(7411), __webpack_require__.e(6060), __webpack_require__.e(3266), __webpack_require__.e(4083), __webpack_require__.e(3951)]).then(() => (() => ((__webpack_require__(3951)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});